module.exports = __webpack_public_path__ + "static/media/RedHeart.e27b28b4.png";